import React, { useEffect } from 'react';
import { MapContainer, TileLayer, FeatureGroup, Polygon, useMap } from 'react-leaflet';
import { EditControl } from 'react-leaflet-draw';
import L from 'leaflet';

function Recenter({ position }) {
  const map = useMap();
  const lat = position?.[0];
  const lng = position?.[1];
  useEffect(() => {
    if (lat != null && lng != null) {
      map.setView([lat, lng], 13, { animate: true });
    }
  }, [lat, lng, map]);
  return null;
}

export const ZoneEditor = ({ zones = [], onCreate, onEdit, onDelete, center = [45.4642, 9.19] }) => {
  return (
    <div className="rounded-2xl overflow-hidden border border-[--brand-border] shadow-[var(--shadow-sm)] h-[520px]">
      <MapContainer center={center} zoom={13} style={{ height: '100%', width: '100%' }}>
        <Recenter position={center} />
        <TileLayer
          attribution='&copy; <a href="https://openstreetmap.org">OSM</a>'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <FeatureGroup>
          <EditControl
            position="topright"
            onCreated={(e) => {
              const layer = e.layer;
              const geo = layer.toGeoJSON();
              onCreate?.(geo.geometry);
              // remove immediately from group; app will re-render via zones state
              layer.remove();
            }}
            draw={{
              polygon: {
                shapeOptions: { color: '#1F6F5B', weight: 2, fillOpacity: 0.18 },
                allowIntersection: false,
                showArea: true,
              },
              polyline: false,
              rectangle: false,
              circle: false,
              circlemarker: false,
              marker: false,
            }}
            edit={{ edit: false, remove: false }}
          />
          {zones.map((z) => (
            <Polygon
              key={z.id}
              positions={geoJsonToLatLngs(z.polygon)}
              pathOptions={{ color: z.color || '#1F6F5B', weight: 2, fillOpacity: 0.18 }}
              eventHandlers={{
                click: () => onEdit?.(z),
              }}
            />
          ))}
        </FeatureGroup>
      </MapContainer>
    </div>
  );
};

function geoJsonToLatLngs(polygon) {
  if (!polygon || polygon.type !== 'Polygon') return [];
  return polygon.coordinates[0].map(([lng, lat]) => [lat, lng]);
}
